import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme: any) => {
  return {
    content: {
      display: 'flex',
      paddingTop: '135px',
      height: '100vh',
      flexDirection: 'column',
      width: '467px',
      margin: '0px auto',
      alignItems: 'center',
      textAlign: 'center',
    },
    icon: {
      width: '96px',
      height: '96px',
      color: theme.custom.colors.error,
      marginBottom: '26px',
    },
    title: {
      font: theme.custom.font.montserrat25,
      color: theme.custom.colors.primary,
    },
    desc: {
      marginTop: '13px',
      font: theme.custom.font.montserrat16,
      color: theme.custom.colors.primary,
    },
    actions: {
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
      marginTop: '24px',
    },
  };
});

export default useStyles;
